module.exports = __webpack_public_path__ + "static/game-4-5c3de2b4e9cfbb91f59c09da47f1e53f.png";